/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RevokedInputs */

const cs_enum_revoked = /** @type {(inputs: Enum_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odvoláno`)
};

const en_enum_revoked = /** @type {(inputs: Enum_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoked`)
};

/**
* | output |
* | --- |
* | "Revoked" |
*
* @param {Enum_RevokedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_revoked = /** @type {((inputs?: Enum_RevokedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RevokedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_revoked(inputs)
	return cs_enum_revoked(inputs)
});